import React, { useEffect, useRef } from 'react'
import styled from 'styled-components';

import vw, { vwDesktop } from 'src/styles/utils';
import media from 'src/styles/media';
import Intl from 'src/components/Intl';

const BREAK_POINT_1 = 1;
const BREAK_POINT_2 = 10;
const BREAK_POINT_3 = 20;

function InvestInAmazing() {
  const amazing1Ref = useRef(null)
  const amazing2Ref = useRef(null)
  const amazing3Ref = useRef(null)
  const amazing4Ref = useRef(null)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [])

  const handleScroll = () => {
    let lastScrollY = window.scrollY;
    
    let tmpBreakPoint1 = BREAK_POINT_1;
    let tmpBreakPoint2 = BREAK_POINT_2;
    let tmpBreakPoint3 = BREAK_POINT_3;

    if (window.innerWidth > 576) {
      let animationStartPoint = 2*amazing4Ref.current.clientHeight;

      tmpBreakPoint1 += animationStartPoint;
      tmpBreakPoint2 += animationStartPoint;
      tmpBreakPoint3 += animationStartPoint;
    } 

    if (lastScrollY > tmpBreakPoint1) {
      amazing1Ref.current.classList.add('show');
      amazing1Ref.current.style.maxHeight = `${2*19*(lastScrollY-tmpBreakPoint1)/window.innerHeight}px`;
    } else {
      amazing3Ref.current.classList.remove('show');
    }

    if (lastScrollY > tmpBreakPoint2) {
      amazing2Ref.current.classList.add('show');
      amazing2Ref.current.style.maxHeight = `${2*40*(lastScrollY-tmpBreakPoint2)/window.innerHeight}px`;
    } else {
      amazing2Ref.current.classList.remove('show');
    }
    if (lastScrollY > tmpBreakPoint3) {
      amazing3Ref.current.classList.add('show');
      amazing3Ref.current.style.maxHeight = `${2*61*(lastScrollY-tmpBreakPoint3)/window.innerHeight}px`;
    } else {
      amazing1Ref.current.classList.remove('show');
    }
  }

  return (
    <Intl>
      {(t, { locale }) => {
        return (
          <Root>
            <h1>Invest In</h1>
            <Amazing1 ref={amazing1Ref}>Amazing</Amazing1>
            <Amazing2 ref={amazing2Ref}>Amazing</Amazing2>
            <Amazing3 ref={amazing3Ref}>Amazing</Amazing3>
            <h1 ref={amazing4Ref}>Amazing</h1>
            <Content>
              {t.invest}
            </Content>
          </Root>
        );
      }}
      </Intl>
  )
}

const Root = styled.section`
  ${vw('padding-top', 28, 80, 49)}
  ${vw('padding-bottom', 48, 80, 70)}

  h1 {
    font-family: Gotham Black;
    font-style: normal;
    font-weight: 900;
    text-transform: uppercase;
    color: #000000;
    background-color: white;
    ${vw('font-size', 51, 125, 122)}
    ${vw('line-height', 49, 120, 117)}
    ${vw('letter-spacing', 0.48, 0.12, 0.2)}

    &:first-of-type {
      text-align: center;
      color: #A5926f;
      z-index: 10;
      ${vw('font-size', 48, 115, 113)}
      ${vw('line-height', 46, 110, 108)}
      ${vw('letter-spacing', 0.48, 0.12, 0.156)}
      
      @media ${media.desktop} {
        max-width: ${vwDesktop(617)};
        margin-left: ${vwDesktop(100)};
      }
    }

    &:last-of-type {
      color: #A5926F;
      z-index: 10;
      ${vw('margin-left', 25, 60, 100)}
      ${vw('margin-right', 25, 60, 0)}
    } 
  }

  .show {
    opacity: 1;
    position: relative;
  }
`;

const Amazing1 = styled.div`
  font-family: Gotham Black;
  font-style: normal;
  font-weight: 900;
  text-transform: uppercase;
  color: #000000;
  border-bottom: 1px solid #000000;
  background-color: white;
  z-index: 1;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  position: absolute;
  transition: opacity 0.1s ease-out;
  ${vw('height', 9, 14, 19)}
  ${vw('font-size', 51, 125, 122)}
  ${vw('line-height', 49, 120, 117)}
  ${vw('letter-spacing', 0.48, 0.12, 0.2)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 0)}
  ${vw('margin-bottom', 10, 22)}
`;

const Amazing2 = styled.div`
  font-family: Gotham Black;
  font-style: normal;
  font-weight: 900;
  text-transform: uppercase;
  color: #000000;
  border-bottom: 1px solid #000000;
  background-color: white;
  z-index: 2;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  position: absolute;
  transition: opacity 0.1s ease-out;
  ${vw('height', 17, 37, 40)}
  ${vw('font-size', 51, 125, 122)}
  ${vw('line-height', 49, 120, 117)}
  ${vw('letter-spacing', 0.48, 0.12, 0.2)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 0)}
  ${vw('margin-bottom', 10, 22)}
`;

const Amazing3 = styled.div`
  font-family: Gotham Black;
  font-style: normal;
  font-weight: 900;
  text-transform: uppercase;
  color: #000000;
  border-bottom: 1px solid #000000;
  background-color: white;
  z-index: 3;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  position: absolute;
  transition: opacity 0.1s ease-out;
  ${vw('height', 24, 61)}
  ${vw('font-size', 51, 125, 122)}
  ${vw('line-height', 49, 120, 117)}
  ${vw('letter-spacing', 0.48, 0.12, 0.2)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 0)}
  ${vw('margin-bottom', 10, 22)}
`;

const Content = styled.div`
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 0)}

  h5 {
    font-family: Gotham Bold;
    font-style: normal;
    font-weight: normal;
    text-transform: uppercase;
    color: #000000;
    ${vw('font-size', 13, 30, 28)}
    ${vw('line-height', 21, 33, 32)}
    ${vw('letter-spacing', 0, 0.84)}
    ${vw('margin-top', 20, 15, 18)}
    ${vw('margin-bottom', 7, 19, 20)}
    span{
      ${vw('font-size', 13, 25, 25)}
    }
  }

  p {
    font-family: Big Caslon;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    ${vw('font-size', 13, 16)}
    ${vw('line-height', 25, 32)}
    ${vw('max-width', 648, 620)}
  }
`;

export default InvestInAmazing

